import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CommunicationService {

  private _modalExecutedSource = new Subject<string>();
  modalExecuted$ = this._modalExecutedSource.asObservable();

  private _burgerClickedSource = new Subject<boolean>();
  public burgerClicked$ = this._burgerClickedSource.asObservable();

  private _shouldReloadSubLists = new Subject<void>();
  public shouldReloadSubLists$ = this._shouldReloadSubLists.asObservable();

  constructor() { }

  public setModalExecuted(executed: string): void {
    this._modalExecutedSource.next(executed);
  }

  public setNavState(opened: boolean): void {
    this._burgerClickedSource.next(opened);
  }

  public reloadSublists(): void {
    this._shouldReloadSubLists.next();
  }

}
